<template>
  <Container type="card-full">
    <div slot="header">
      <el-button @click="addOrEdit" :loading="btnLoading" type="primary"
        >保存</el-button
      >
      <el-button @click="showdialog" :loading="btnLoading" type="primary"
        >提交</el-button
      >
      <el-button @click="viewptc" :loading="btnLoading" type="primary"
        >采购协议预览</el-button
      >
    </div>
    <div>
      <div class="main">
        <el-form
          :model="ptc"
          ref="ruleForm"
          label-position="right"
          class="mainfrom"
        >
          <div>
            <div class="row from_input">
              <el-form-item label="协议编号" prop="ptccode" verify>
                {{ ptc.ptccode }}
              </el-form-item>
            </div>
            <!-- <div class="row from_input">`  
                    <el-form-item  label="外部编号" prop="ptcoutcode" verify>
                        <el-input v-model="ptc.ptcoutcode" :maxlength="20"></el-input>
                    </el-form-item>
                </div> -->
            <div class="content-title">
              <el-form-item label="协议名称" prop="ptcname" verify>
                <el-input v-model="ptc.ptcname" :maxlength="128"></el-input>
              </el-form-item>
            </div>
            <div class="row from_input">
              <el-form-item label="预算金额" prop="ptcbudgetamt">
                <el-input
                  v-model="ptc.ptcbudgetamt"
                  @blur="inputMoney($event, 'ptcbudgetamt')"
                ></el-input>
                <amount
                  :money="String(ptc.ptcbudgetamt)"
                  v-if="ptc.ptcbudgetamt"
                />
              </el-form-item>
            </div>
            <div class="row from_input">
              <el-form-item label="采购人" prop="ptcpcomname" verify>
                <div style="width: 200px; margin: 0 5px">
                  {{ ptc.ptcpcomname }}
                </div>
                <vxe-button
                  type="primary"
                  size="small"
                  @click="showCgr"
                  icon="el-icon-search"
                  style="height: 38px"
                ></vxe-button>
              </el-form-item>
            </div>
            <div class="row from_input">
              <el-form-item label="联系人" prop="ptctpuserid" verify>
                <el-select v-model="ptc.ptctpuserid" @change="getpUserTel">
                  <el-option
                    v-for="(item, index) in auserList"
                    :label="item.label"
                    :value="item.value"
                    :key="index"
                  ></el-option>
                </el-select>
              </el-form-item>
              <!-- 弹出框 -->
              <el-popover
                placement="right"
                width="700"
                trigger="click"
                v-model="popflg"
                @show="showpop"
              >
                <div>
                  <div style="margin-bottom: 20px">
                    <el-input
                      style="width: 80%; margin-right: 20px"
                      @input="inputchange"
                      v-model="username"
                      placeholder="请输入联系人姓名"
                      clearable
                    />
                    <el-button type="primary" @click="getaUserdialogList"
                      >搜索</el-button
                    >
                  </div>
                  <vggrid
                    :random="Math.floor(Math.random() * 999999)"
                    :list="auserDList"
                    tableheight="600"
                    flexname=""
                    :cols="Ucols"
                    :showfooter="false"
                    :showPage="true"
                    :resizable="true"
                    :defaultPage="5"
                    :total="Uquery.total"
                    @pagechange="pagechange"
                    @cellClick="viewProject"
                  >
                    <template slot="btn">
                      <div class="btn-box">
                        <vxe-button
                          type="text"
                          icon="el-icon-plus"
                          @click="addUser"
                        >
                          新增
                        </vxe-button>
                        <vxe-button
                          type="text"
                          icon="el-icon-edit-outline"
                          @click="chgUser"
                        >
                          修改
                        </vxe-button>
                      </div>
                    </template>
                  </vggrid>
                </div>
                <el-button
                  slot="reference"
                  type="primary"
                  size="small"
                  icon="el-icon-search"
                  style="height: 38px"
                ></el-button>
              </el-popover>
            </div>
            <div class="from-value">
              <el-form-item label="手机">
                <!-- <el-input v-model="ptc.usermobile" :maxlength="20"></el-input> -->
                <div class="value">
                  {{ ptc.usermobile ? ptc.usermobile : "暂无" }}
                </div>
              </el-form-item>
            </div>
            <div class="from-value">
              <el-form-item label="电话">
                <!-- <el-input v-model="ptc.usertel" :maxlength="20"></el-input> -->
                <div class="value">
                  {{ ptc.usertel ? ptc.usertel : "暂无" }}
                </div>
              </el-form-item>
            </div>
            <div class="from-value">
              <el-form-item label="邮箱">
                <!-- <el-input v-model="ptc.useremail" :maxlength="20"></el-input> -->
                <div class="value">
                  {{ ptc.useremail ? ptc.useremail : "暂无" }}
                </div>
              </el-form-item>
            </div>
            <div class="row from_input">
              <!-- <el-form-item  label="交易方式" prop="ptctrademode" verify>
                        <el-input v-model="ptc.ptctrademode" :maxlength="20"></el-input>
                    </el-form-item> -->
              <el-form-item label="交易方式" prop="ptctrademode" verify>
                <el-select v-model="ptc.ptctrademode" placeholder="请选择">
                  <el-option
                    v-for="item in projectprsflgList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </div>
            <div class="row from_input">
              <el-form-item label="选择模板">
                <el-select
                  placeholder="请选择"
                  v-model="ptc.tmplchoose"
                  @change="setTmplContent"
                  clearable
                >
                  <el-option
                    v-for="item in templateOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </div>

            <div class="row from_input">
              <el-form-item label="协议内容" prop="ptctext" verify>
                <div
                  ref="editorNR"
                  style="text-align: left; width: 850px"
                ></div>
              </el-form-item>
            </div>
            <!-- <div class="row from_input">
                    <el-form-item  label="协议文件" prop="projectptel" verify>
                        <el-input v-model="ptc.projectptel" :maxlength="20"></el-input>
                    </el-form-item>
                </div> -->
            <el-form-item label="协议文件">
              <div class="file">
                <div class="uploadbtn">
                  <upload-btn @changed="setfile" text="上传文件"></upload-btn>
                </div>
                <div
                  v-if="appends && appends.appendfilename"
                  style="display: flex"
                >
                  <div
                    style="
                      color: #2f74ff;
                      cursor: pointer;
                      padding-right: 20px;
                      cursor: pointer;
                    "
                    @click="downFile(appends.appendurl)"
                  >
                    <a :src="$store.getters.uploadAddr + appends.appendurl">{{
                      appends.appendfilename
                    }}</a>
                  </div>
                  <div
                    @click="delappend(appends)"
                    style="color: #2f74ff; cursor: pointer"
                  >
                    删除
                  </div>
                </div>
              </div>
            </el-form-item>
          </div>
          <div class="split-line"></div>
          <el-form-item class="from-value" label="业务员">
            <div class="value">
              {{ dptObj.dptname }} / {{ dptObj.username }} /
              {{ dptObj.usercode }}
            </div>
          </el-form-item>
          <!-- dptObj -->
        </el-form>
      </div>
    </div>

    <el-dialog title="选择采购人" :visible.sync="cgrflg" width="50%">
      <div style="margin-bottom: 20px">
        <el-input
          style="width: 80%; margin-right: 20px"
          @change="getSearchPcomList"
          @input="inputchange"
          v-model="comname"
          placeholder="请输入采购人名称"
          clearable
        />
        <el-button type="primary" @click="getSearchPcomList">搜索</el-button>
      </div>
      <vggrid
        :random="Math.floor(Math.random() * 999999)"
        :list="pcomList"
        tableheight="600"
        flexname=""
        :cols="cols"
        :showfooter="false"
        :showPage="true"
        :resizable="true"
        :total="query.total"
        @pagechange="pagechange"
      >
      </vggrid>
    </el-dialog>

    <el-dialog
      title="协议提交(提交时必须分派给具体执行的项目部门）"
      :visible.sync="cwpbtflg"
      width="50%"
    >
      <el-form :model="ptc" ref="ruleT" label-position="right" class="mainfrom">
        <div class="row from_input">
          <el-form-item label="分派项目部" prop="ptcdptid" verify>
            <el-select v-model="ptc.ptcdptid" filterable>
              <el-option
                v-for="(item, index) in dptList"
                :label="item.label"
                :value="item.value"
                :key="index"
              ></el-option>
            </el-select>
          </el-form-item>
        </div>
        <!-- <div class="row from_input">
                <el-form-item label="协议文件" >
                    <div class="file">
                        <div  class="uploadbtn">
                        <upload-btn @changed='setfile' text="上传文件"></upload-btn>
                        </div>
                        <div v-if="appends && appends.appendfilename" style="display:flex;">
                            <div style="color: #2f74ff;cursor: pointer;padding-right: 20px;cursor: pointer;"
                                @click="downFile(appends.appendurl)">
                                <a :src="$store.getters.uploadAddr + appends.appendurl">{{appends.appendfilename}}</a>
                            </div>
                            <div @click="delappend(appends)" style="color: #2f74ff;cursor: pointer;">删除</div>
                        </div>
                    </div>
                </el-form-item>
            </div> -->
        <div class="row from_input">
          <el-form-item label=" ">
            <el-button type="primary" @click="submitdpt">提交</el-button>
          </el-form-item>
        </div>
      </el-form>
    </el-dialog>
  </Container>
</template>

<script>
import request from "@/utils/request";
import _ from "lodash";
import E from "wangeditor";
import utils from "../../assets/js/utils";
import config from "../../assets/config";
import common from "@/mixin/common";
import uploadBtn from "../common/uploadBtn";
import vggrid from "../common/vggrid";
import amount from "../common/amount";
import dayjs from "dayjs";

export default {
  name: "ptcEdit",
  mixins: [common],
  data() {
    return {
      ptc: {},
      btnLoading: false,
      cglxrflg: false,
      cgrflg: false,
      popflg: false,
      comname: "",
      username: "",
      userComid: "",
      dptObj: {},
      auserList: [], //采购人列表
      auserDList: [], //弹框出来的采购人列表
      projectprsflgList: [],
      dptList: [], //部门列表
      appends: {}, //协议文件
      templateOptions: [], //模板名称
      user: {},
      cwpbtflg: false,
      query: {
        comneme: "",
        total: 0,
        limit: 10,
        offset: 0,
      },
      Uquery: {
        username: "",
        total: 0,
        limit: 5,
        offset: 0,
      },
      pcomList: [],
      cols: [
        {
          type: "index",
          fieldtype: "I",
          title: "行号",
          calculExpr: "",
          width: 50,
        },
        {
          field: "comfullname",
          fieldtype: "C",
          title: "采购人",
          calculExpr: "",
          addNewRowFlg: false,
        },
        {
          title: "操作 ",
          showOverflow: true,
          slots: {
            default: ({ row }) => {
              return [
                <vxe-button onClick={this.confirmCom.bind(this, row)}>
                  确认
                </vxe-button>,
              ];
            },
          },
        },
      ],
      Ucols: [
        {
          type: "index",
          fieldtype: "I",
          title: "行号",
          calculExpr: "",
          width: 50,
        },
        {
          field: "username",
          fieldtype: "C",
          title: "姓名",
          calculExpr: "",
          addNewRowFlg: false,
        },
        {
          field: "usercode",
          fieldtype: "C",
          title: "手机",
          calculExpr: "",
          addNewRowFlg: false,
        },
        {
          title: "操作 ",
          showOverflow: true,
          slots: {
            default: ({ row }) => {
              return [
                <vxe-button onClick={this.confirmUser.bind(this, row)}>
                  确认
                </vxe-button>,
              ];
            },
          },
        },
      ],
      editorNRDesc: "",
      editorNR: "",
    };
  },
  async created() {},
  filters: {},
  mounted() {},
  deactivated() {
    this.$destroy();
  },
  async activated() {
    await this.init();
    await this.getPrsflgList();
    await this.initEditorNR();
    await this.getaUserList();
    await this.getTemplateOptions();
  },
  components: { vggrid, uploadBtn, amount },
  computed: {
    uploadAddr() {
      return this.$store.getters.uploadAddr;
    },
  },
  methods: {
    async init() {
      this.appends = {};
      await this.getptcInfo();
      this.userComid = this.ptc.ptcpcomid;
      await this.getaUserList();
      await this.getDptList();
    },
    async getSearchPcomList() {
      this.query.cosid = this.$store.getters.loginUser.cosid;
      this.query.comtype = "2";
      //代理单位
      if (this.$store.getters.loginUser.comtype === "1") {
        this.query.comid = null;
      }
      //采购人
      if (this.$store.getters.loginUser.comtype === "2") {
        this.query.comid = this.$store.getters.loginUser.usercomid;
      }
      this.query.comcodename = this.comname;

      let res = await request({
        method: "get",
        url: "/ywgl/com/getPageList",
        params: this.query,
      });
      this.pcomList = res.list;
      this.query.total = res.count[0].count;
    },
    inputMoney(el, name) {
      let val = utils.delcommafy(el.target.value);
      var reg = /^[0-9]+.?[0-9]*$/;
      if (reg.test(val)) {
        this.ptc[name] = utils.getInputValue(el);
      }
    },
    async getptcInfo() {
      let data = await request({
        url: "/xmgl/ptc/getptcInfo",
        method: "get",
        params: { ptcid: this.$route.params.ptcid },
      });
      this.ptc = data;
      this.ptc.ptcbudgetamt = data.ptcbudgetamt
        ? utils.comdify(utils.delcommafy(data.ptcbudgetamt))
        : data.ptcbudgetamt;
      this.appends = this.ptc.appends ? this.ptc.appends : {};
      this.dptObj = this.ptc.dptObj;
      this.editorNRDesc = this.ptc.ptctext;
    },
    async pagechange(page) {
      this.query.offset = page.pageSize * (page.currentPage - 1);
      this.query.limit = page.pageSize;
      this.getSearchPcomList();
    },
    inputchange(e) {
      this.comname = e.replace(/[, ]/g, "");
    },
    async showCgr() {
      this.cgrflg = true;
      this.getSearchPcomList();
    },
    async viewProject(row) {
      this.user = row.row;
    },
    async showCglxr() {
      if (this.ptc.ptcpcomid) {
        this.cglxrflg = true;
      } else {
        this.$message.warning("请先选择采购人");
        return;
      }
    },
    async confirmCom(row) {
      this.$set(this.ptc, "ptcpcomname", row.comfullname);
      this.$set(this.ptc, "ptcpcomid", row.comid);
      this.userComid = row.comid;
      await this.getaUserList();
      if (this.auserList.length > 0) {
        this.$set(this.ptc, "ptctpuserid", this.auserList[0].userid);
        await this.getpUserTel(this.ptc.ptctpuserid);
      }
      this.cgrflg = false;
    },
    async confirmUser(row) {
      let user = this.auserDList.find((item) => item.userid === row.userid);
      this.$set(this.ptc, "ptctpuserid", user.userid);
      this.ptc.useremail = user.username;
      this.ptc.usertel = user.usertel;
      this.ptc.usermobile = user.usermobile;
      this.popflg = false;
    },
    async getaUserList() {
      this.userComid = this.ptc.ptcpcomid;
      this.auserList = await request({
        method: "get",
        url: "/xtgl/user/getUserList",
        params: { comid: this.userComid },
      });
      // if(this.auserList.length > 0){
      //     this.$set(this.ptc,'ptctpuserid',this.auserList[0].userid)
      //     await this.getpUserTel(this.ptc.ptctpuserid)
      // }
    },
    async getaUserdialogList() {
      let form = {};
      form = this.Uquery;
      form.username = this.username;
      form.comid = this.userComid;
      let res = await request({
        method: "get",
        url: "/xtgl/user/getPageList",
        params: form,
      });
      this.auserDList = res.list;
      this.Uquery.total = res.count[0].count;
    },
    async getpUserTel(userid) {
      let user = this.auserList.find((item) => item.userid === userid);
      this.ptc.useremail = user.useremail;
      this.ptc.usertel = user.usertel;
      this.ptc.usermobile = user.usermobile;
    },
    async addOrEdit() {
      if (+this.ptc.ptcbudgetamt === 0 && this.ptc.ptcbudgetamt) {
        this.$message.warning("预算不能为0");
        return;
      }
      this.ptc.ptctext = this.editorNRDesc;
      this.ptc.ptccosid = this.$store.getters.loginUser.cosid;
      this.ptc.ptcmodifyuserid = this.$store.getters.loginUser.userid;
      this.ptc.appends = this.appends;
      this.ptc.ptcbudgetamt = this.ptc.ptcbudgetamt
        ? utils.delcommafy(this.ptc.ptcbudgetamt)
        : null;
      this.submitForm("ruleForm")
        .then(async () => {
          let data = await request({
            url: "/xmgl/ptc/saveptc",
            method: "post",
            data: this.ptc,
          });
          if (data.issuccess === 1) {
            this.$message.success("保存成功");
            await this.getptcInfo();
            return;
          }
        })
        .catch(() => {});
      // this.btnLoading = false
    },
    async addUser() {
      let form = {
        userid: 0,
        usercomid: this.ptc.ptcpcomid,
        userstatus: "1",
        comtype: 2,
        userlockflg: "1",
      };
      this.$router.push({ name: "userForm", params: { form: form, type: 1 } });
    },
    async chgUser() {
      if (!this.user.userid) {
        this.$message.warning("请选择一个用户!");
        return;
      }
      this.$router.push({
        name: "userForm",
        params: { form: this.user, type: 2 },
      });
    },
    async showpop() {
      if (this.userComid) {
        await this.getaUserdialogList();
        this.popflg = true;
      } else {
        this.popflg = false;
        this.$message.warning("请先选择采购人");
        return;
      }
    },
    close() {
      this.$store.commit("close_tab", {
        routeName: this.$route.name,
        vm: this,
        newRouteName: "ptcindex",
      });
    },
    async getPrsflgList() {
      this.projectprsflgList = await request({
        url: "/kfgl/syscode/getSysCodeList",
        method: "get",
        params: { syscode: "prsflg" },
      });
    },
    async initEditorNR() {
      if (this.editorNR && this.ptc.ptctext) {
        this.editorNR.txt.html(this.ptc.ptctext);
        return;
      }
      this.editorNR = new E(this.$refs.editorNR);
      this.editorNR.config.onchange = (html) => {
        this.editorNRDesc = html;
        html === "<p><br></p>" && (this.editorNRDesc = "");
      };
      this.editorNR.config.uploadFileName = "file";
      this.editorNR.config.uploadImgServer = `${config.baseUrl}upload/upload`;
      this.editorNR.config.zIndex = 1;
      this.editorNR.create();
      if (this.ptc.ptctext) {
        this.editorNR.txt.html(this.ptc.ptctext);
      }
    },
    async setfile(path, filename) {
      this.appends = {
        appendid: 0,
        appendfromid: 0,
        appendfromtype: "22",
        appendtype: "100",
        appendseq: 1,
        appendfilecode: "",
        appendfilename: filename,
        appendurl: path.replace(this.uploadAddr, ""),
      };
    },
    delappend(file) {
      this.$confirm(`确定移除 ${file.appendfilename}？`, "提示", {
        type: "warning",
      })
        .then(() => {
          this.appends = {};
        })
        .catch(() => {});
    },
    async getDptList() {
      this.dptList = await request({
        method: "get",
        url: "/xtgl/dpt/getDptList",
        params: { comid: this.$store.getters.loginUser.comid },
      });
    },
    showdialog() {
      this.ptc.ptctext = this.editorNRDesc;
      this.ptc.appends = this.appends;
      if (this.appends) {
        if (!this.appends.appendfromtype) {
          this.$message.warning("请上传协议文件");
          return;
        }
      }
      this.ptc.ptcdptid = this.$store.getters.loginUser.userdptid;
      this.submitForm("ruleForm")
        .then(async () => {
          this.cwpbtflg = true;
        })
        .catch(() => {});
    },
    close() {
      this.$store.commit("close_tab", {
        routeName: this.$route.name,
        vm: this,
        newRouteName: "ptcindex",
      });
    },
    async submitdpt() {
      this.ptc.ptctext = this.editorNRDesc;
      this.ptc.appends = this.appends;
      if (this.appends) {
        if (!this.appends.appendfromtype) {
          this.$message.warning("请上传协议文件");
          return;
        }
      }
      this.submitForm("ruleT")
        .then(async () => {
          this.$confirm("提交后不能修改，请确认是否提交", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          })
            .then(async () => {
              this.ptc.ptccosid = this.$store.getters.loginUser.cosid;
              this.ptc.ptcsubmituserid = this.$store.getters.loginUser.userid;
              this.ptc.appends = this.appends;
              this.ptc.ptcbudgetamt = this.ptc.ptcbudgetamt
                ? utils.delcommafy(this.ptc.ptcbudgetamt)
                : null;
              this.ptc.ptcstatus = 1;
              let data = await request({
                url: "/xmgl/ptc/submitdpt",
                method: "post",
                data: this.ptc,
              });
              if (data.issuccess === 1) {
                this.$message.success("保存成功");
                this.close();
                return;
              }
            })
            .catch(() => {});
        })
        .catch(() => {});
    },
    async setTmplContent() {
      if (!this.ptc.tmplchoose) return;
      // if (!this.ptc.ptctrademode) {
      //   this.$message.warning("采购类型未选择");
      //   this.ptc.tmplchoose = ""
      //   return;
      // }
      if (!this.editorNRDesc) {
        this.setTemplate();
        return;
      }

      this.$confirm(
        `按模板生成协议文本，将覆盖现有的协议，是否继续？`,
        "提示",
        {
          confirmButtonText: "是",
          cancelButtonText: "否",
          type: "warning",
        }
      )
        .then(async () => {
          await this.setTemplate();
        })
        .catch(() => {
          this.ptc.tmplchoose = "";
        });
    },
    async setTemplate() {
      let model = {};
      model.selectField = `tmplcontent`;
      // model.tmpltype = 6;
      model.tmplid = this.ptc.tmplchoose;
      let res = await request({
        url: "/xmgl/tmpl/getTemplate",
        method: "get",
        params: model,
      });
      if (!res) {
        this.$message.warning("没有该类型模板！");
        return;
      }
      //模板内容
      let tmplCon = {};
      tmplCon.ptcname = this.ptc.ptcname;
      tmplCon.ptccode = this.ptc.ptccode;
      tmplCon.purchase_comname = this.ptc.comfullname;
      tmplCon.purchase_username = this.ptc.pusername;
      tmplCon.purchase_comAddr = this.ptc.comaddr;
      tmplCon.purchase_tel = this.ptc.comtel;
      tmplCon.acting_comname = this.$store.getters.loginUser.comfullname;
      tmplCon.acting_username = this.$store.getters.loginUser.username;
      tmplCon.acting_comAddr = this.$store.getters.loginUser.comaddr;
      tmplCon.acting_tel = this.$store.getters.loginUser.comtel;
      tmplCon.ptcbudgetamt = this.ptc.ptcbudgetamt;
      tmplCon.ptcbudgetamt_up = utils.smallToBig(
        utils.comdify(this.ptc.ptcbudgetamt)
      );
      tmplCon.nowTime = utils.ConverToDate(dayjs().format("YYYY-MM-DD"));
      tmplCon.nowDate = dayjs().format("YYYY");
      tmplCon.aaddr =
        +this.$store.getters.loginUser.dptbranchfalg === 1
          ? this.$store.getters.loginUser.dptaddress
          : this.$store.getters.loginUser.comaddr;
      tmplCon.acomname =
        +this.$store.getters.loginUser.dptbranchfalg === 1
          ? this.$store.getters.loginUser.dptfullname
          : this.$store.getters.loginUser.comfullname;

      let tm = res.tmplcontent;
      let compiled = _.template(tm || "");

      this.editorNRDesc = compiled(tmplCon);
      this.editorNR.txt.html(compiled(tmplCon));
    },
    async viewptc() {
      let { href } = this.$router.resolve({
        name: "viewptc",
        query: { ptcid: this.ptc.ptcid },
      });
      window.open(href, "_blank");
    },
    async getTemplateOptions() {
      this.templateOptions = await request({
        method: "get",
        url: "/xmgl/tmpl/getTemplateOptions",
        params: { tmplcosid: this.$store.getters.loginUser.cosid, tmpltype: 6 },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
//   @import "../../styles/filelist";
.main {
  .from_input .el-input,
  .el-input .el-input__inner,
  .el-select {
    width: 200px;
  }
  .content-title {
    display: flex;
    .el-input {
      width: 514px;
    }
    .el-cascader {
      width: 200px;
    }
  }
  .content .el-textarea__inner,
  .el-textarea {
    width: 840px;
  }
  .file {
    display: flex;
    flex-direction: column;
    // width: 50%;
    .uploadbtn {
      display: flex;
      span {
        padding-left: 10px;
        color: red;
      }
    }
  }
  .checkbox_w {
    width: 45px;
  }
  .file {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    .filelist {
      .fileitem {
        display: flex;

        .btn {
          color: #409eff;
        }
      }
    }
    // width: 50%;
    .uploadbtn {
      display: flex;
      span {
        padding-left: 10px;
        color: red;
      }
    }
  }
}
</style>
